import {Component} from '@angular/core';
import {Router} from "@angular/router";

@Component({
    selector: 'db-booster',
    templateUrl: './booster-pro-temp.component.html',
    styleUrls: ['./booster-pro-temp.component.scss'],
    standalone: false
})
export class BoosterProTempComponent {


  constructor(
    private _router: Router
) {
    this._router.navigate(['/upgrade-plan']);
  }

}
